export default __webpack_public_path__ + "static/icon-resource-depletion-370da8fcda28f2858ca45c9859bfec3a.svg";